var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleIntegrations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a65b226d-ca7d-41fd-958d-09faf4065365",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.76,
    height: 12.54,
    viewBox: "0 0 12.76 12.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-53337adf-3394-408c-95cf-92a335712482",
    "data-name": "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.38,6.38s-.05,0-.08-.02L.1,3.24C.04,3.21,0,3.14,0,3.08c0-.07.04-.13.1-.15L6.3.02s.1-.02.15,0l6.2,2.91c.06.03.1.09.1.15,0,.07-.04.13-.1.16l-6.2,3.12s-.05.02-.08.02ZM.57,3.09l5.81,2.92,5.81-2.92L6.38.37.57,3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38,8.37s-.05,0-.08-.02L.1,5.23C.04,5.2,0,5.14,0,5.07c0-.07.04-.13.1-.15l1.33-.62c.09-.04.19,0,.23.08s0,.19-.08.23l-1.01.47,5.81,2.92,5.81-2.92-1.02-.48c-.09-.04-.12-.14-.08-.23.04-.09.14-.12.23-.08l1.35.63c.06.03.1.09.1.15,0,.07-.04.13-.1.16l-6.2,3.12s-.05.02-.08.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38,10.35s-.05,0-.08-.02L.1,7.2C.04,7.17,0,7.11,0,7.05c0-.07.04-.13.1-.15l1.33-.62c.09-.04.19,0,.23.08s0,.19-.08.23l-1.01.47,5.81,2.92,5.81-2.92-1.02-.48c-.09-.04-.12-.14-.08-.23.04-.09.14-.12.23-.08l1.35.63c.06.03.1.09.1.15,0,.07-.04.13-.1.16l-6.2,3.12s-.05.02-.08.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38,12.54s-.05,0-.08-.02L.1,9.4c-.06-.03-.1-.09-.1-.16,0-.07.04-.13.1-.15l1.33-.62c.09-.04.19,0,.23.08.04.09,0,.19-.08.23l-1.01.47,5.81,2.92,5.81-2.92-1.02-.48c-.09-.04-.12-.14-.08-.23.04-.09.14-.12.23-.08l1.35.63c.06.03.1.09.1.15,0,.07-.04.13-.1.16l-6.2,3.12s-.05.02-.08.02Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleIntegrations);
export default __webpack_public_path__ + "static/media/icon_module_integrations.66cdab3d735cc69aa7abd000ce08d001.svg";
export { ForwardRef as ReactComponent };